/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlContainEndpointAction = {
    Isolate: 'isolate',
    Lock: 'lock'
} as const;
export type ControlContainEndpointAction = typeof ControlContainEndpointAction[keyof typeof ControlContainEndpointAction];


export function ControlContainEndpointActionFromJSON(json: any): ControlContainEndpointAction {
    return ControlContainEndpointActionFromJSONTyped(json, false);
}

export function ControlContainEndpointActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlContainEndpointAction {
    return json as ControlContainEndpointAction;
}

export function ControlContainEndpointActionToJSON(value?: ControlContainEndpointAction | null): any {
    return value as any;
}

